import React, { ReactNode, useMemo } from 'react';
import {
  PostHogProvider as PostHogNativeProvider,
  usePostHog,
} from 'posthog-react-native';
import { EventsProvider } from '@/contexts/EventsProvider/EventsContext';
import { createPostHogProvider } from '@/api/services/events';
import { posthog } from '@/contexts/EventsProvider/posthogClient';

interface PostHogEventsProviderProps {
  children: ReactNode;
  onInitialized?: () => void;
  onError?: (error: Error) => void;
}

export const PostHogEventsProvider: React.FC<PostHogEventsProviderProps> = ({
  children,
  onInitialized,
  onError,
}) => {
  return (
    <PostHogNativeProvider autocapture={false} client={posthog}>
      <PostHogEventsProviderInner
        onInitialized={onInitialized}
        onError={onError}
      >
        {children}
      </PostHogEventsProviderInner>
    </PostHogNativeProvider>
  );
};

interface PostHogEventsProviderInnerProps {
  children: ReactNode;
  onInitialized?: () => void;
  onError?: (error: Error) => void;
}

const PostHogEventsProviderInner: React.FC<PostHogEventsProviderInnerProps> = ({
  children,
  onInitialized,
  onError,
}) => {
  const posthog = usePostHog();

  const provider = useMemo(() => createPostHogProvider(posthog), [posthog]);

  return (
    <EventsProvider
      provider={provider}
      onInitialized={onInitialized}
      onError={onError}
    >
      {children}
    </EventsProvider>
  );
};
